"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParticipantOrderState = void 0;
var ParticipantOrderState;
(function (ParticipantOrderState) {
    ParticipantOrderState["IsPreOrder"] = "isPreOrder";
    ParticipantOrderState["IsPaid"] = "isPaid";
    ParticipantOrderState["IsPaidViaLinkedIn"] = "isPaidViaLinkedIn";
    ParticipantOrderState["IsVoucher"] = "isVoucher";
})(ParticipantOrderState = exports.ParticipantOrderState || (exports.ParticipantOrderState = {}));
//# sourceMappingURL=participant-order-state.js.map